import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { RoleTypes } from '@core/authentication/shared/role-types.enum';
import { UrlLanguageReplaceService } from '@core/utils/url-language-replace';

import { IHelpMenuModel } from '../shared/help-menu.model';
import { HelpMenuService } from '../shared/help-menu.service';

@Component({
    template: require('./help-menu.content.component.html'),
    selector: 'ndd-help-menu-content',
})
export class HelpMenuContentComponent implements OnInit {

    public get helpUrlAdministrator(): string {
        return this.manualModel.urlAdministrator = this.urlLanguageReplaceService
            .replaceLanguage(this.manualModel.urlAdministrator);
    }
    public get helpUrlUser(): string {
        return this.manualModel.urlUser = this.urlLanguageReplaceService
            .replaceLanguage(this.manualModel.urlUser);
    }
    public manualModel: IHelpMenuModel;
    public isPartnerRestrict: boolean;
    public isUser: boolean;

    constructor(
        private authTokenService: AuthTokenService,
        private urlLanguageReplaceService: UrlLanguageReplaceService,
        private helpMenuService: HelpMenuService) { }

    public ngOnInit(): void {
        // tslint:disable-next-line: no-bitwise
        if (this.authTokenService.role & RoleTypes.Partners) {
            // tslint:disable-next-line: no-bitwise
            this.isPartnerRestrict = !!(this.authTokenService.role & RoleTypes.PartnerRestrict);
        }

        // tslint:disable-next-line:no-bitwise
        if (this.authTokenService.role & RoleTypes.User) {
            this.isUser = true;
        }

        this.helpMenuService.getManualUrls()
            .pipe(take(1))
            .subscribe((model: IHelpMenuModel) => {
                this.manualModel = model;
            });
    }
}
